export const menu = () => [
    { key: 0, name: 'Главная', url: '/', parent: 0 },
    { key: 1, name: 'Украшения из бисера', url: '/ukrasheniya', parent: 0 },
    { key: 2, name: 'Статьи и схемы', url: '/articles', parent: 0 },
    { key: 3, name: 'Браслеты', url: '/braslet', parent: 1 },
    { key: 4, name: 'Колье и бусы', url: '/bousi', parent: 1 },
    { key: 5, name: 'Цветы', url: '/cvetochki', parent: 1 },
    { key: 6, name: 'Брелоки и аксессуары', url: '/breloki-aksessuary', parent: 1 },
    { key: 7, name: 'Украшение одежды', url: '/otdelka', parent: 1 },
    { key: 8, name: 'Квадратный столбик', url: '/kvadrat-stolbik', parent: 2 },
    { key: 9, name: 'Кулон «Солнышко»', url: '/solnishko', parent: 2 },
    { key: 10, name: 'Подставка под чашку', url: '/podstavka', parent: 2 },
    { key: 11, name: 'Веточка из бисера', url: '/vetochka', parent: 2 },
    { key: 12, name: 'Плетение крестиком', url: '/krestik', parent: 2 },
    { key: 13, name: 'История бисероплетения', url: '/history', parent: 2 },
    { key: 14, name: 'Шнур из бисера', url: '/shnur', parent: 2 },
    { key: 15, name: 'Сетчатое плетение', url: '/vosmerka', parent: 2 },
    { key: 16, name: 'Оплетение бусин', url: '/opletenie-bousin', parent: 2 },
    { key: 17, name: 'Круглый брелок', url: '/circle-brelok', parent: 2 },
];